module.exports = __webpack_public_path__ + "img/13_13.71977074.png";